import axios from 'axios';

const fetchPDFDataWithCoordinates = async payload => {
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');
  const headers = {
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken,
    Accept: 'application/json'
  };
  try {
    const response = await axios.get(
      `https://cipilot-lexai-api-318242574572.us-central1.run.app/application_mapping/mappings/with_coordinates?doc_id=${payload.doc_id}&application_id=${payload.application_id}&page_number=${payload.pageNumber}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching PDF JSON data:', error);
  }
};

const fetchSearchResultsPDF = async payload => {
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');
  const headers = {
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken,
    Accept: 'application/json'
  };
  try {
    const response = await axios.get(
      `https://cipilot-lexai-api-318242574572.us-central1.run.app/application_mapping/mappings/search?doc_id=${payload.doc_id}&query_text=${payload.query_text}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching PDF JSON data:', error);
  }
};

const fetchPDFDataWithOutCoordinates = async payload => {
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');
  const headers = {
    'X-Access-Token': accessToken,
    'X-Refresh-Token': refreshToken,
    Accept: 'application/json'
  };
  try {
    const response = await axios.get(
      `https://cipilot-lexai-api-318242574572.us-central1.run.app/application_mapping/mappings/without_coordinates?doc_id=${payload.doc_id}&application_id=${payload.application_id}&page_number=${payload.pageNumber}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching PDF JSON data:', error);
  }
};

const transformDataWithCoordinates = input => {
  const grouped = {};
  input.forEach(item => {
    const { key, value, x1, y1, x2, y2, id } = item;
    if (!grouped[key]) {
      grouped[key] = {
        value,
        coordinates: { x1, y1, x2, y2 },
        id // Include the ID here for proper overlay-JSON sync
      };
    }
  });
  return [grouped];
};

const transformDataWithOutCoordinates = input => {
  // Group items by key, allowing duplicates
  const grouped = {};
  input.forEach(item => {
    const { key, value, id } = item;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push({ value, id });
  });
  return [grouped];
};

export {
  fetchPDFDataWithCoordinates,
  fetchPDFDataWithOutCoordinates,
  transformDataWithCoordinates,
  transformDataWithOutCoordinates,
  fetchSearchResultsPDF
};
